import React, { useEffect, useState } from "react";
import { Button, Grid, Typography, Paper, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/system";
import DatePickers from "../../pickers/DatePicker";
import { createContract, validateEndDateByPeriodicity } from "../../action";
import { Form, Field } from "react-final-form";
import { formatDateFromISO } from "../../utils/helper";
import CalendarPicker from "../../pickers/CalenderPicker";
import dayjs from "dayjs";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));
const ContractDeclaration = ({ policyHolderId, setSnackbarMessage }) => {
  const SignInSuccess = useSelector((state) => state);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const store = useSelector((state) => state.profileReducer);
  const onSubmit = async (values) => {
    const dateValidFromVal = values.dateValidFrom || store?.endDate?.start_date;
    const value = {
      dateValidFrom: dateValidFromVal,
      ...values,
      policyHolderId: policyHolderId?.id,
      dateValidTo: store?.endDate?.end_date,
    };
    dispatch(createContract(value, policyHolderId?.id));
    setSnackbarMessage(t("Contract Create Sucessfully"));
  };
  const onDateValidFromChange = (values) => {
    dispatch(validateEndDateByPeriodicity(values, policyHolderId?.id));
  };

  useEffect(() => {
    if (policyHolderId?.id) {
      dispatch(validateEndDateByPeriodicity("", policyHolderId?.id));
    }
  }, [policyHolderId?.id]);

  const validate = (values) => {
    const errors = {};
    // if (
    //   !!values.dateValidFrom &&
    //   !!store?.endDate &&
    //   !!store?.endDate?.includes("Please")
    // ) {
    //   errors.dateValidTo = store?.endDate;
    // }

    return errors;
  };

  // const handleMonthYearChange = (newValue) => {
  //   const year = newValue.year();
  //   const month = newValue.month();
  //   const firstDayOfMonth = dayjs().year(year).month(month).date(1);
  //   onChange(firstDayOfMonth.format("YYYY-MM-DD"));
  // };
  return (
    <Grid container>
      <Grid item xs={12}>
        <StyledPaper>
          <StyledPaperHeader>
            {/* <Grid></Grid> */}
            <Grid item alignItems="center">
              <Typography variant="h6">{t("General Information")}</Typography>
            </Grid>
          </StyledPaperHeader>
          <Form
            onSubmit={onSubmit}
            validate={validate}
            render={({
              handleSubmit,
              form,
              submitting,
              pristine,
              values,
              errors,
            }) => (
              // setFormValues(values),
              <form onSubmit={handleSubmit}>
                <Grid
                  style={{
                    display: "flex",
                    marginLeft: ".5rem",
                    marginTop: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Grid item xs={3} className="common-input">
                    <Field
                      name="dateValidFrom"
                      component={CalendarPicker}
                      onChange={(value) => {
                        form.change("dateValidFrom", value);
                        onDateValidFromChange(value);
                      }}
                      label={t("Valid Month From")}
                      type="text"
                      monthYear
                      formatDate="DD-MM-YYYY"
                      disabled={store?.endDate && store?.endDate?.start_date}
                      inputVal={
                        store?.endDate &&
                        store?.endDate?.start_date &&
                        formatDateFromISO(store?.endDate?.start_date)
                      }
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    <Field
                      name="dateValidTo"
                      component={CalendarPicker}
                      onChange={(value) => form.change("dateValidTo", value)}
                      label={t("Valid Month To")}
                      type="text"
                      formatDate="DD-MM-YYYY"
                      disabled
                      inputVal={
                        store?.endDate &&
                        store?.endDate?.end_date &&
                        formatDateFromISO(store?.endDate?.end_date)
                      }
                      error={!!store?.endDate}
                      // errorMessage={
                      //   !!store?.endDate &&
                      //   !!store?.endDate?.includes("Please") &&
                      //   store?.endDate
                      // }
                    />
                  </Grid>
                  <Grid item xs={8} style={{ marginTop: "1.5rem" }}>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      // disabled={
                      //   (!!store?.endDate &&
                      //     !!store?.endDate?.includes("Please")) ||
                      //   !values?.dateValidFrom
                      //     ? true
                      //     : false
                      // }
                    >
                      {t("Create new Delcaration")}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            )}
          />
        </StyledPaper>
      </Grid>
    </Grid>
  );
};

export default ContractDeclaration;
